<template>
    <div class="search-list">
        <div class="input-box" >
            <svg class="svg-icons">
                <use :xlink:href="require('@/assets/img/icons/magnify.svg')+'#layer'"></use>
            </svg>
            <input v-model="filter" :placeholder="placeholder" @keyup="search()"/>
        </div>
        <div class="item-list" v-if="loading">
            <container-loader class="item-loader"/>
        </div>
        <div
            v-else-if="value.length > 0"
            class="item-list"
            :style="{
                height: height === undefined ? null :
                (isNaN(height) ? height : `${height}px`)
            }"
        >
            <div v-for="(it, i) in value" :key="i" class="item">
                <b-checkbox 
                    v-if="checkable"
                    type="is-primary" 
                    class="lbl"
                    style="width: 100%"
                    @input="onCheck(it, i)" 
                    :disabled="it.disabled"
                    v-model="it.check"> 
                    <div class="columns">
                        <div class="column" style="align-self: center;">
                                <span>
                                    {{ it[label] }}
                                </span>
                        </div>
                        <div v-if="it.tiposervico" class="column is-5" style="align-self: center;">
                            <span v-if="it.tiposervico">
                                {{ $t('tipo-servico').toLocaleUpperCase() + ': ' + it.tiposervico}}
                            </span>
                        </div>
                        <div v-for="(label, index) of aditionalFields" :key="index" class="column is-3" style="align-self: center;">
                            <span>
                                {{ it[label] }}
                            </span>
                        </div>
                        <div class="column is-1">
                            <span class="situacao" v-if="it.situacao == 0 && checkable" >
                                <b-tag class="table-tag" type="is-danger" size="is-small">
                                    {{$t('inativo')}}
                                </b-tag>
                            </span>
                        </div>
                    </div>
                </b-checkbox>
                <!-- @84447 - Se for passada a situação, será exibida, caso seja inativa -->
                <h3 v-if="!checkable" 
                    class="lbl">
                    <span>
                        {{ 'pacoca' }}
                    </span>
                </h3>
                <span class="situacao" v-if="it.situacao == 0 && !checkable" >
                    <b-tag class="table-tag" type="is-danger" size="is-small">
                        {{$t('inativo')}}
                    </b-tag>
                </span>
            </div>
        </div>
        <empty-table-message v-else class="mt-5"/>
    </div>
</template>

<script>
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    props: {
        value: {
            type: Array,
            default: () => []
        },
        label: {
            type: String,
            default: "label"
        },
        checkable: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: "Search here..."
        },
        onSearch: {
            type: Function,
            default: filter => {
                return this.value.filter(i => i[label].includes(filter));
            }
        },
        onCheck: {
            type: Function,
            default: () => {}
        },
        loading: {
            type: Boolean,
            default: false
        },
        height: {
            type: String,
            default: null
        },
        aditionalFields: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            filter: ""
        };
    },
    components: {
        ContainerLoader
    },
    methods: {
        search() {
            this.onSearch(this.filter);
        }
    }
};
</script>
<style lang ="scss">
    span.control-label{
        width: 100%;
    }

</style>

<style lang="scss" scoped>
.search-list{
    display: flex;
    flex-direction: column;
    height: 100%;
    
    .input-box{
        flex: 0 0 auto;
    }
    .item-list{
        flex: 1 1 auto;
    }
}

.input-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 38px;
    border-bottom: 1px solid $table-border;

    input {
        font-size: 18px;
        margin-left: 0;
        margin-right: 0;
        outline: none;
        border: none;
        padding: 4px;
        color: $darker-gray-color;
        box-shadow: none;
    }

    svg {
        width: 40px;
    }
}

.item {
    position: relative;
    height: 40px;
    display: flex;
    &:hover, &:active {
        background-color: $darker-bg-color;
    }
    
    .lbl {
        height: 100%;
        color: $darker-gray-color;
        padding: 10px;
    }
}

.item-list {
    overflow: auto;
    position: relative;

    .item-loader {
        background: transparent;
    }
}

table {
    width: 100%;
    margin-top: 15px;
}

table td {
    border: none;
}

tr {
    width: 100%;
}

td {
    padding: 10px;
    &.check-column {
        width: 40px;
    }
}

.situacao {
    align-self: center;
}
</style>


